import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/user': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M313.6 304C284.9 304 271.1 320 224 320 176.9 320 163.2 304 134.4 304 60.2 304 0 364.2 0 438.4V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V438.4C448 364.2 387.8 304 313.6 304zM400 464H48V438.4C48 390.8 86.8 352 134.4 352 149 352 172.7 368 224 368 275.7 368 298.9 352 313.6 352 361.2 352 400 390.8 400 438.4V464zM224 288C303.5 288 368 223.5 368 144S303.5 0 224 0 80 64.5 80 144 144.5 288 224 288zM224 48C276.9 48 320 91.1 320 144S276.9 240 224 240 128 196.9 128 144 171.1 48 224 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/user.js
// module id = Dmnq
// module chunks = 144